// extracted by mini-css-extract-plugin
module.exports = {"table":"Dokumente_table__3IjUT","new":"Dokumente_new__m_8Xs","toggle":"Dokumente_toggle__3fCd8"};